<template>
  <div class="chain-supplier-container">
    <el-row :gutter="20">
      <el-col :span="4" style="padding-right: 0">
        <chain-supplier-tree ref="chainSupplierTree" @switchSupplier="handleSwitchSupplier" @switchCatalog="handleSwitchCatalog" />
      </el-col>
      <el-col :span="20" class="">
        <el-row>
          <el-col :span="24">
            <el-card>
              <div slot="header" class="clearfix flex justify-bettwen">
                <span>{{ $t('chainSupplier.queryCondition') }}</span>
              </div>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-input
                    v-model="chainSupplierInfo.conditions.prodName"
                    :placeholder="$t('chainSupplier.productNamePlaceholder')"
                    clearable
                  />
                </el-col>
                <el-col :span="6">
                  <el-input
                    v-model="chainSupplierInfo.conditions.productId"
                    :placeholder="$t('chainSupplier.productIdPlaceholder')"
                    clearable
                  />
                </el-col>
                <el-col :span="4">
                  <el-button type="primary" @click="handleQuery">
                    <i class="el-icon-search"></i>
                    {{ $t('chainSupplier.query') }}
                  </el-button>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row>

        <el-row class="margin-top-xs">
          <el-col :span="24">
            <el-card>
              <el-table
                :data="chainSupplierInfo.products"
                style="width: 100%"
                border
                stripe
              >
                <el-table-column prop="productId" :label="$t('chainSupplier.productId')" align="center" />
                <el-table-column :label="$t('chainSupplier.productImage')" align="center">
                  <template slot-scope="scope">
                    <el-image
                      style="width: 50px; height: 50px"
                      :src="scope.row.coverPhoto"
                      :preview-src-list="[scope.row.coverPhoto]"
                    >
                      <div slot="error" class="image-slot">
                        <img src="/img/noPhoto.jpg" style="width: 50px; height: 50px">
                      </div>
                    </el-image>
                  </template>
                </el-table-column>
                <el-table-column prop="catalogName" :label="$t('chainSupplier.productCategory')" align="center" />
                <el-table-column prop="prodName" :label="$t('chainSupplier.productName')" align="center" />
                <el-table-column prop="unitName" :label="$t('chainSupplier.productUnit')" align="center" />
                <el-table-column prop="sort" :label="$t('chainSupplier.sort')" align="center" />
                <el-table-column :label="$t('chainSupplier.status')" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.state === '2002' ? $t('chainSupplier.onShelf') : $t('chainSupplier.offShelf') }}
                  </template>
                </el-table-column>
                <el-table-column prop="createTime" :label="$t('chainSupplier.createTime')" align="center" />
                <el-table-column :label="$t('chainSupplier.operation')" align="center">
                  <template slot-scope="scope">
                    <el-button size="mini" @click="handlePurchase(scope.row)">
                      {{ $t('chainSupplier.purchase') }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>

              <div class="pagination-container">
                <el-pagination
                  background
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="chainSupplierInfo.total"
                  :page-size="chainSupplierInfo.conditions.row"
                  :current-page="chainSupplierInfo.conditions.page"
                  @current-change="handlePageChange"
                  @size-change="handleSizeChange"
                />
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <add-chain-supplier-product ref="addChainSupplierProduct" />
  </div>
</template>

<script>
import { listChainProduct } from '@/api/goods/chainSupplierApi'
import ChainSupplierTree from '@/components/goods/chainSupplierTree/chainSupplierTree'
import AddChainSupplierProduct from '@/components/goods/addChainSupplierProduct/addChainSupplierProduct'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ChainSupplier',
  components: {
    ChainSupplierTree,
    AddChainSupplierProduct
  },
  data() {
    return {
      chainSupplierInfo: {
        conditions: {
          products: [],
          prodName: '',
          csId: '',
          catalogId: '',
          productId: '',
          shopId: '',
          page: 1,
          row: 10
        },
        products: [],
        total: 0
      }
    }
  },
  created() {
    this.chainSupplierInfo.conditions.shopId = getShopId()
    console.log(this.chainSupplierInfo.conditions.products)
    this.listProducts()
  },
  methods: {
    listProducts() {
      listChainProduct(this.chainSupplierInfo.conditions).then(response => {
        this.chainSupplierInfo.products = response.data
        this.chainSupplierInfo.total = response.total
      })
    },
    handleQuery() {
      this.chainSupplierInfo.conditions.page = 1
      this.listProducts()
    },
    handlePageChange(page) {
      this.chainSupplierInfo.conditions.page = page
      this.listProducts()
    },
    handleSizeChange(size) {
      this.chainSupplierInfo.conditions.row = size
      this.listProducts()
    },
    handleSwitchSupplier(params) {
      this.chainSupplierInfo.conditions.csId = params.csId
      this.chainSupplierInfo.conditions.catalogId = ''
      this.listProducts()
    },
    handleSwitchCatalog(params) {
      this.chainSupplierInfo.conditions.csId = params.csId
      this.chainSupplierInfo.conditions.catalogId = params.catalogId
      this.listProducts()
    },
    handlePurchase(product) {
      this.$refs.addChainSupplierProduct.open(product)
    }
  }
}
</script>

<style lang="scss" scoped>
.chain-supplier-container {

  .margin-top-xs {
    margin-top: 10px;
  }
  .pagination-container {
    margin-top: 15px;
    text-align: right;
  }
}
</style>